var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"streamer-type-card"},[_c('settings-card',{attrs:{"config":_vm.config},on:{"setting":_vm.settings}}),_c('company-business-category-modal',{ref:"modal"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }